import { fadeIn } from "../utils/fade"

export class CurrencyDropdown {
  constructor() {
    this.tabElements = document.querySelectorAll(".plan")
    this.initializeCurrencies()
    this.initAddonToggleBtns()
  }

  initializeCurrencies() {
    let currency_code = document.querySelector(".current_selected_currency")
      ? document.querySelector(".current_selected_currency").textContent.toLowerCase()
      : ""
    let currency_symbol = currency_code
      ? document
        .querySelector(`.dropdown-item[data-code=${currency_code}]`)
        .getAttribute("data-value")
      : ""

    const savedCurrency = localStorage.getItem("selectedCurrency") || currency_code
    const savedCurrencySymbol = localStorage.getItem("selectedCurrencySymbol") || currency_symbol

    this.tabElements.forEach((tab) => {
      const currencyDropdown = tab.querySelector(".currency-dropdown")
      const currencyList = currencyDropdown.querySelector(".dropdown-list")
      const currencyButton = currencyDropdown.querySelector(".dropdown-button span")

      this.updateCurrency(currencyButton, savedCurrency)
      this.updateCurrencySymbol(savedCurrencySymbol)

      this.addEventListeners(currencyList, currencyButton)
    })
    this.updatePlanPrice(savedCurrency)
    this.updateAddonPrice(savedCurrency)

    document.querySelectorAll(".current-item").forEach((item) => {
      item.classList.remove("current-item")
    })

    document.querySelectorAll(".currency-dropdown .dropdown-item").forEach((currencyItem) => {
      if (
        currencyItem &&
        currencyItem.getAttribute("data-code").toLowerCase() === savedCurrency.toLowerCase()
      ) {
        currencyItem.classList.add("current-item")
      }
    })
  }

  saveCurrencyToLocalStorage(currencyCode, currencySymbol) {
    localStorage.setItem("selectedCurrency", currencyCode)
    localStorage.setItem("selectedCurrencySymbol", currencySymbol)
  }

  addEventListeners(currencyList, currencyButton) {
    currencyList.querySelectorAll(".dropdown-item").forEach((currencyItem) => {
      currencyItem.addEventListener("click", (e) => {
        this.changeCurrency(e.target, currencyButton)
      })
    })
  }

  changeCurrency(target, currencyButton) {
    const selectedCurrencyCode = target.textContent.trim()
    const currencySymbol = target.getAttribute("data-value")
    document.querySelector(".current-item").classList.remove("current-item")
    target.classList.add("current-item")

    this.saveCurrencyToLocalStorage(selectedCurrencyCode, currencySymbol)

    this.updateCurrency(currencyButton, selectedCurrencyCode)

    this.updateAllCurrencies(selectedCurrencyCode)

    this.updateCurrencySymbol(currencySymbol)

    this.updatePlanPrice(selectedCurrencyCode)

    this.updateAddonPrice(selectedCurrencyCode)
  }

  updatePlanPrice(selectedCurrencyCode) {
    document.querySelectorAll(".dynamic_price_change").forEach((item) => {
      item.textContent = ` ${item.getAttribute(`data-price-${selectedCurrencyCode.toLowerCase()}`)}`
    })
  }

  updateCurrency(currencyButton, currencyCode) {
    currencyButton.textContent = currencyCode
  }

  updateAllCurrencies(currencyCode) {
    const allCurrencyButtons = document.querySelectorAll(".currency-dropdown .dropdown-button span")
    allCurrencyButtons.forEach((button) => {
      button.textContent = currencyCode
    })
  }

  updateCurrencySymbol(currencySymbol) {
    const priceElements = document.querySelectorAll(".price-symbol span")
    priceElements.forEach((element) => {
      element.style.setProperty("--currency-symbol", `"${currencySymbol}"`)
    })
  }

  initAddonToggleBtns() {
    const addonsCards = document.querySelectorAll(".addons_card")
    addonsCards.forEach((card) => {
      const toggle = card.querySelector(".toggler")
      const togglerItems = card.querySelectorAll(".card_toggler-item")
      const cardPrice = card.querySelector(".card_price span")

      if (!toggle || togglerItems.length < 2 || !cardPrice) return

      toggle.addEventListener("click", () => {
        if (toggle.querySelector("span").classList.contains("active")) {
          toggle.querySelector("span").classList.remove("active")
          togglerItems[0].classList.add("active")
          togglerItems[1].classList.remove("active")

          fadeIn(cardPrice, 300, () => {
            cardPrice.textContent = cardPrice.getAttribute(
              `data-price-regular-${
                document.querySelector(".current_selected_currency").textContent.toLowerCase() ||
                "usd"
              }`,
            )
          })
        } else {
          toggle.querySelector("span").classList.add("active")
          togglerItems[0].classList.remove("active")
          togglerItems[1].classList.add("active")

          fadeIn(cardPrice, 300, () => {
            cardPrice.textContent = cardPrice.getAttribute(
              `data-price-advanced-${
                document.querySelector(".current_selected_currency").textContent.toLowerCase() ||
                "usd"
              }`,
            )
          })
        }
      })
    })
  }

  updateAddonPrice(currencySymbol) {
    document.querySelectorAll(".addons_card").forEach((AddonCard) => {
      let current_price = AddonCard.querySelector(".card_price span")
      if (current_price) {
        if (AddonCard.querySelector(".card_toggler .active") !== null) {
          current_price.textContent = current_price.getAttribute(
            `data-price-advanced-${currencySymbol.toLowerCase() || "usd"}`,
          )
        } else {
          current_price.textContent = current_price.getAttribute(
            `data-price-regular-${currencySymbol.toLowerCase() || "usd"}`,
          )
        }
      }
    })
  }
}
